
import axios from "axios";
import { baseApiUrl } from "../../../env";
import axiosInstance from "../../../Axios/axios";

const baseUrl =`${baseApiUrl}/api/v1/`;










const getAllCustomers=async({queryKey:getCustomerInfo})=>{
  
     const getAllCustomer_URL='Customer/GetAllCustomers';
    
     return await axiosInstance.post(getAllCustomer_URL,getCustomerInfo[1])
     
  }
  


  // addCustomer
  const addCustomer=async(customerData)=>{
    const addCustomer_URL='Customer/AddCustomer';
    return await axiosInstance.post(addCustomer_URL,customerData)
  }


  // deleteCustomer
  const deleteCustomer=async(id)=>{
    const deleteCustomerURL='Customer/DeleteCustomer?customerId'
    return await axiosInstance.delete(`${deleteCustomerURL}=${id}`)
  }


// getSingleCustomerData
const getSingleCustomerData=async(id)=>{
    const getSingleCustomerData_URL='Customer/GetSingleCustomer';
    return await axiosInstance.post(getSingleCustomerData_URL,id)
}



// editCustomer
  const editCustomer=async(EditedData)=>{
    const editCustomer_URL='Customer/EditCustomer'
    return await axiosInstance.post(editCustomer_URL,EditedData)
  }


// deleteCustomerPrices
const deleteCustomerPrices=async(id)=>{
    const customerCommunicationDelet_Url='CustomerPrice/DeleteCustomerPrice?customerPriceId'
    return await axiosInstance.delete(`${customerCommunicationDelet_Url}=${id}`)
  }

 

// DeleteCustomerCommunication
const DeleteCustomerCommunication=async(id)=>{
     const deleteCustomerCommunication_URL='CustomerCommunication/DeleteCustomerCommunication?customerCommunicationServiceId'
    return await axiosInstance.delete(`${deleteCustomerCommunication_URL}=${id}`)
}


 

// getPrintingMachineType
const getPrintingMachineType= async()=>{
  const printingMachineType_URL='PrintingMachineType/GetAllPrintingMachineType'
    return await axiosInstance.get(printingMachineType_URL)
}




// getAllApi
const getAllApi=async()=>{
  const lpiBody={
    page: 0,
    totalRecords: 0,
    pageSize: 0,
    searchTerm: ""
  }
    const getAllLpi_URL='Order/GetAllLPI';
    return await axiosInstance.post(getAllLpi_URL,lpiBody)
}





// getCustomerStatusType
const getCustomerStatusType= async ()=>{
  const customerStatusType_URL='CustomerStatusType/GetCustomerStatusType'
    return await axiosInstance.get(customerStatusType_URL)

}




// getCustomerReceiveFileType
const getCustomerReceiveFileType=async()=>{
  const customerReceiveFileType_URL='CustomerReceivedFileType/GetCustomerReceivedFileType';
    return await axiosInstance.get(customerReceiveFileType_URL)
}





//getCustomerGradeType
const getCustomerGradeType=async()=>{
  const customerGradType_URL='CustomerGradeType/GetCustomerGradeType';
  return await axiosInstance.get(customerGradType_URL)
}



// getAllDesigners
const getAllDesigners=async()=>{
    const getOrderExpert_URL='User/GetUnitUsers?customerRoleType=2';
    return  await axiosInstance.get(getOrderExpert_URL)
}


//getSaleExpert
const getSaleExpert=async()=>{
    const getSaleExpert_URL='User/GetUnitUsers?customerRoleType=1'
    return await axiosInstance.get(getSaleExpert_URL)
}


// getDeptCollectors
const getDeptCollectors=async()=>{
    const deptCollectors_URL='User/GetUnitUsers?customerRoleType=3';
    return await axiosInstance.get(deptCollectors_URL)
}


const getCollectionClaims=async()=>{
  const deptCollectors_URL='User/GetUnitUsers?customerRoleType=5';
  return await axiosInstance.get(deptCollectors_URL)
}



// getCustomerDeliverType
const getCustomerDeliverType=async()=>{
    const getCustomerDeliveryTypes_URL='CustomerDeliverType/GetCustomerDeliverType'
    return await axiosInstance.get(`${getCustomerDeliveryTypes_URL}`)
}




// getCustomerDeliverMethod
const getCustomerDeliverMethod=async({queryKey})=>{
   let id=queryKey[1];
   const getCustomerDeliveryMethod_URL='CustomerDeliverMethod/GetCustomerDeliverMethod?CustomerDeliverTypeId'
   return await axiosInstance.get(`${getCustomerDeliveryMethod_URL}=${id}`)
}



// getSingleCustomer
const getSingleCustomer=async(id)=>{
    const getSingleCustomer_URL='Customer/GetCustomerView';
    return await axiosInstance.post(getSingleCustomer_URL,id)
}


// getRegisterationPrices
const getRegisterationPrices=async({queryKey})=>{
  const klischePriceBody={
    "page": 1,
    "totalRecords": 0,
    "pageSize": 20
  }
    const getKlischePrice_URL='GetAllKlischePrice/GetKlischePrice'
    return await axiosInstance.post(getKlischePrice_URL,klischePriceBody)
  }




// deleteCustomerSendInfo
const deleteCustomerSendInfo=async(id)=>{
  const baseUrlSps ="http://192.168.3.17:99";
  const existToken=localStorage.getItem('accessToken');
  const deleteCustomerSendInfo_URL=`${baseApiUrl}/DeleteCustomerDeliverInfo?customerDeliverInfoId`
  return await axiosInstance.delete(`${deleteCustomerSendInfo_URL}=${id}`)
}


// deleteCustomerMachine
    const deleteCustomerMachine=async(id)=>{
    const deleteCustomerMachine_URL='MachineInfo/DeleteMachineInfo?machineInfoId';
    return await axiosInstance.delete(`${deleteCustomerMachine_URL}=${id}`)
}


// deleteCustomerAniloxe
const deleteCustomerAniloxe=async(id)=>{
const deleteCustomerAnilox_URL='MachineInfo/DeleteAniloxInfo?aniloxId';
return await axiosInstance.delete(`${deleteCustomerAnilox_URL}=${id}`)
}



// deleteCustomerCylinder
const deleteCustomerCylinder=async(id)=>{
    const deleteCustomerCylinder_URL='MachineInfo/DeleteCylinderInfo?cylinderInfoId';
    return await axiosInstance.delete(`${deleteCustomerCylinder_URL}=${id}`);
}



// getCustomerWorkBranch
const getCustomerWorkBranch=async()=>{
    const getWorkBranch_URL='CustomerWorkBranch/GetCustomerWorkBranch';
    return await axiosInstance.get(getWorkBranch_URL)
}



// getAllDpi
const getAllDpi=async()=>{
  const getAllDpi_URL='Dpi/GetAllDpi';
  return await axiosInstance.get(getAllDpi_URL)
}



// getLpi
const getLpi=async({queryKey})=>{
  let dpiId=queryKey[1]
  const getLpi_URL=`Lpi/GetLpiByDpiId?dpiId`;
  return await axiosInstance.get(`${getLpi_URL}=${dpiId}`)
}

// getMachineProfile
const getMachineProfile=async()=>{
  const getMachineProfile_URL='MachineProfile/GetAllMachineProfile';
  return await axiosInstance.get(`${getMachineProfile_URL}`)
}



// deleteMachineDpiLpi
const deleteMachineDpiLpi=(id)=>{
  const deleteDpiLpi_URL='MachineDpi_Lpi/DeleteMachineDpi_Lpi?Id'
  axiosInstance.delete(`${deleteDpiLpi_URL}=${id}`)
}



const getKlischeTypeCategory=async()=>{
  const getKlischTypeCategoryURL='KlischeTypeCategory/GetKlischeTypeCategory';
  return await axiosInstance.get(getKlischTypeCategoryURL)
}

const getKlischeThinknessByCategoryId=async({queryKey})=>{
  let categoryId=queryKey[1]
 const GetKlischeThinknessByCategoryId_URL='KlischePrice/GetKlischeThinknessByCategoryId';
 return await axiosInstance.post(GetKlischeThinknessByCategoryId_URL,categoryId)
}

// http://192.168.3.17:91/api/v1/Customer/GetCustomersDetailGroup


const getCustomerDetailGroup=async()=>{

  return await axiosInstance.get('Customer/GetCustomersDetailGroup')

}

// http://192.168.3.17:91/api/v1/Customer/GetAllBatizCustomers

const GetAllBatizCustomers=async()=>{
  return await axiosInstance.get('Customer/GetAllBatizCustomers')
}

// http://192.168.3.17:91/api/v1/Customer/ValidateCustomerAccountingCode
const validateCustomerAccountingCode=async({queryKey})=>{
  let code=queryKey[1];
  const validateCustomerAccountingCode_URL=`Customer/ValidateCustomerAccountingCode`;
  return await axiosInstance.post(validateCustomerAccountingCode_URL,code)
}

// http://192.168.3.17:91/api/v1/Customer/GetAllCustomerQCTypes

const GetAllCustomerQCTypes=async()=>{
  return await axiosInstance.get('Customer/GetAllCustomerQCTypes')
}

// http://192.168.3.17:91/api/v1/CustomerPrice/DeleteCustomerPriceHistory?customerPriceId=3fa85f64-5717-4562-b3fc-2c963f66afa6

const DeleteCustomerPriceHistory=async(id)=>{

    return await axiosInstance.delete(`CustomerPrice/DeleteCustomerPriceHistory?customerPriceId=${id}`)
  }

  // http://192.168.3.17:91/api/v1/CustomerAging/GetAgingReport

  const GetAgingReport=async({queryKey})=>{
     let body=queryKey[1];
    return await axiosInstance.post(`CustomerAging/GetAgingReport`,body)
  }
  // http://192.168.3.17:91/api/v1/Customer/GetCustomerFilters

  const GetCustomerFilters=async()=>{
  return await axiosInstance.get('Customer/GetCustomerFilters')
}

// http://192.168.3.17:91/api/v1/CustomerAging/GetCustomerDebtLetter
 const GetCustomerDebtLetter=async(body)=>{
    return await axiosInstance.post(`CustomerAging/GetCustomerDebtLetter`,body)
  }
  //    // http://192.168.3.17:91/api/v1/CustomerAging/SaveDebtLetter
const SaveDebtLetter=async(body)=>{
    return await axiosInstance.post(`CustomerAging/SaveDebtLetter`,body)
  }
  // http://192.168.3.17:91/api/v1/CustomerAging/GetCustomerDebtLetters?customerId=3fa85f64-5717-4562-b3fc-2c963f66afa6
  const GetCustomerDebtLetters=async({queryKey})=>{
    let customerId=queryKey[1];
    return await axiosInstance.get(`CustomerAging/GetCustomerDebtLetters?customerId=${customerId}`)
  }



  // http://192.168.3.17:91/api/v1/CustomerAging/GetDebtLetterById?id=3fa85f64-5717-4562-b3fc-2c963f66afa6
   const GetDebtLetterById=async({queryKey})=>{
    let id=queryKey[1];
    return await axiosInstance.get(`CustomerAging/GetDebtLetterById?id=${id}`)
  }



export {
    DeleteCustomerCommunication,
    deleteCustomerPrices,
    getPrintingMachineType,
    getAllApi,
    getCustomerStatusType,
    getCustomerReceiveFileType,
    getAllDesigners,
    getSaleExpert,
    getCustomerGradeType,
    getCustomerDeliverType,
    getCustomerDeliverMethod,
    getDeptCollectors,
    getAllCustomers,
    getSingleCustomer,
    addCustomer,
    deleteCustomer,
    getSingleCustomerData,
    getRegisterationPrices,
    deleteCustomerSendInfo,
    deleteCustomerMachine,
    deleteCustomerAniloxe,
    deleteCustomerCylinder,
    editCustomer,
    getCustomerWorkBranch,
    getAllDpi,
    getLpi,
    getMachineProfile,
    deleteMachineDpiLpi,
    getKlischeTypeCategory,
    getKlischeThinknessByCategoryId,
    getCollectionClaims,
    getCustomerDetailGroup,
    GetAllBatizCustomers,
    validateCustomerAccountingCode,
    GetAllCustomerQCTypes,
    DeleteCustomerPriceHistory,
    GetAgingReport,
    GetCustomerFilters,
    GetCustomerDebtLetter,
    SaveDebtLetter,
    GetCustomerDebtLetters,
    GetDebtLetterById
    
}

